<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <b-list-group  v-for="(item,index) in items" :key="index" class="mt-3">
      <b-list-group-item href="#" active class="flex-column align-items-start">
        <div class="d-flex w-100 justify-content-between">
          <h5 class="mb-1">{{item.event_name}}</h5>
          <small>3 days to go</small>
        </div>
        <p class="mb-1">{{item.sales_group}}</p>
        <p class="mb-1">{{item.event_code}}</p>

        <small>{{item.event_date}}</small>
      </b-list-group-item>
    </b-list-group>
   <!--  {{items}} -->
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";
import moment from "moment";

export default {
  name: "UpNext",
  props: ["tile", "refresh"],
  components: {
    /* DonutChart */
  },
  data() {
    return {
      busy: false,
      timeout: false,
      name: "UpNext",
      items: [],
    };
  },
  async mounted() {
    await this.loadChart();
  },
  watch: {
    refresh: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
    tile: {
      immediate: true,
      async handler(newVal, oldVal) {
        await this.loadChart();
      },
    },
  },
  computed: {
    ...mapGetters(["user"]),
    chartType() {
      if (this.tile.settings) {
        let setting = this.tile.settings.find((o) => o.key == "type");
        return setting.value;
      } else {
        return "Donut";
      }
    },
  },
  methods: {
    async loadChart() {
      console.log("loadChart: UpNext");

      let setting = null;

      this.timeout = false;
      this.busy = true;
      let variables = {
        date: this.$moment().format("YYYY-MM-DD"),
        // email: this.user.email
      };

      // setting = this.tile.settings.find((o) => o.key == "server");
      // if (setting) {
      //   variables.source = setting.value;
      //   this.source = setting.value;
      // }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query events_list($date: String) {
              events_list(date: $date) {
                sales_group
                event_code
                event_name
                event_date
              }
            }
          `,
          variables,
        });
        console.log(response.data.events_list);
        this.items = [];
        for (var i = 0; i < response.data.events_list.length; i++) {
          let item = response.data.events_list[i]
          this.items.push({
            sales_group: item.sales_group,
            event_code: item.event_code,
            event_name: item.event_name,
            event_date: this.$moment.unix(item.event_date / 1000).format("YYYY-MM-DD")
          });
          if (i == 2) {
            break;
          }
        }
        console.log(this.items);
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
      await this.$emit("refreshed");
    },
  },
};
</script>

<style>
</style>